// What the banner shows. `CHECKING` never reaches the store: a silent check keeps whatever was on screen.
export const CONNECTION_STATUS = {
    ONLINE: 'online',
    OFFLINE: 'offline',
    RECONNECTING: 'reconnecting',
    BACK_ONLINE: 'backOnline',
};

export const CONNECTION_QUALITY = {
    GOOD: 'good',
    SLOW: 'slow',
};

export const BANNER_VARIANT = {
    OFFLINE: 'offline',
    RECONNECTING: 'reconnecting',
    BACK_ONLINE: 'backOnline',
    SLOW: 'slow',
};

export const BANNER_COPY = {
    [BANNER_VARIANT.OFFLINE]: {
        title: "You're offline",
        body: 'Please check your internet connectivity.',
    },
    [BANNER_VARIANT.RECONNECTING]: {
        title: 'Reconnecting…',
        body: 'Hold on, this usually takes a few seconds.',
    },
    [BANNER_VARIANT.BACK_ONLINE]: {
        title: "You're back online",
        body: 'You can carry on where you left off.',
    },
    [BANNER_VARIANT.SLOW]: {
        title: 'Your connection is slow',
        body: 'This may take a little longer than usual. Please keep this page open.',
    },
};

// Every timing the feature uses. See the rules at the top of lib/monitor.js.
export const TIMING = {
    // How long one /health check may take before it counts as failed.
    CHECK_TIMEOUT_MS: 5000,
    // Offline needs a second failed check this long after the first, so a brief blip shows nothing.
    CONFIRM_RETRY_MS: 1000,
    // While offline only: how often /health is checked until it answers.
    OFFLINE_RETRY_MS: 5000,
    BACK_ONLINE_DISPLAY_MS: 3000,
    // A real request still waiting this long triggers one timed /health check...
    SLOW_REQUEST_MS: 8000,
    // ...and the connection counts as slow when that check takes longer than this.
    SLOW_CHECK_MS: 2000,
};
